export default "__VITE_ASSET__ca616888__"